package org.hs_soft.runmynesto.pages.login

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import org.hs_soft.runmynesto.di.GlobalKoin
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.login.LoginStateEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.modules.Auth
import org.hs_soft.runmynesto.navigation.Screen
import org.hs_soft.runmynesto.pages.components.RememberWindowSize
import org.hs_soft.runmynesto.pages.login.component.ForgetPasswordSendCode
import org.hs_soft.runmynesto.pages.login.component.LoginTopLogo
import org.hs_soft.runmynesto.pages.login.component.ResetPassword
import org.hs_soft.runmynesto.pages.login.component.SignIn
import org.hs_soft.runmynesto.pages.login.component.VerifySignInCode
import org.hs_soft.runmynesto.pages.login.mvi.LoginEvent
import org.hs_soft.runmynesto.pages.login.mvi.LoginViewModel
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.koin.core.parameter.parametersOf


@Page
@Composable
fun Login()
{
    val context= rememberPageContext()
    val viewModel = remember {
        GlobalKoin.get<LoginViewModel> { parametersOf() }
    }
    val state by viewModel.state.collectAsState()

    LaunchedEffect(Unit) {

        console.log(Auth)
        viewModel.onEvent(LoginEvent.UpdateIsLoggedInStatus)
    }
    viewModel.onEvent(
        LoginEvent.InitWindowsSize(windowsSize = RememberWindowSize())
    )

    LaunchedEffect(state.isLoggedIn){
        if (state.isLoggedIn && !state.isCheckingLoggedInLoading){
            context.router.navigateTo(
                Screen.HomePage.route,
                updateHistoryMode = UpdateHistoryMode.REPLACE,

            )
        }
    }

    if (!state.isLoggedIn && !state.isCheckingLoggedInLoading)
    {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(Theme.White.rgb)
        )
        {
            Column(
                modifier = Modifier
                    .align(Alignment.Center)
                    .width(Dimen.loginLayoutWidth)
                    .height(
                        when(state.loginState){
                            LoginStateEnum.FORGET_PASSWORD_SEND_CODE->{
                                Dimen.forgetPassSendCodeHeight
                            }
                            LoginStateEnum.RESET_PASSWORD->{
                                Dimen.resetPasswordHeight
                            }
                            else-> Dimen.loginLayoutHeight
                        }

                    )
                    .borderRadius(Dimen.semiLargeRadius)
                    .padding(Dimen.semiExtraExtraLargePadding2)
                    .boxShadow(
                        offsetX = 0.px,
                        offsetY = 3.px,
                        blurRadius = 15.px,
                        spreadRadius = 0.px,
                        color = Theme.Gray10.rgb
                    )
                    .border(
                        width = Dimen.smallThickness,
                        color = Theme.Divider.rgb,
                        style = LineStyle.Solid,
                    ),
                horizontalAlignment = Alignment.CenterHorizontally
            )
            {

                LoginTopLogo()

                when(state.loginState)
                {
                    LoginStateEnum.SIGN_IN->{

                        SignIn(
                            email=state.userName,
                            password = state.password,
                            loading=state.isLoading,
                            info=Strings.current().enterLoginRequiredData,
                            onPasswordChange = {
                                viewModel.onEvent(LoginEvent.OnPasswordChange(it))
                            },
                            onEmailChange = {
                                viewModel.onEvent(LoginEvent.OnUserNameChange(it))
                            },
                            onSubmitClick={
                                viewModel.onEvent(
                                    LoginEvent.OnSignInClick(
                                        userName =state.userName,
                                        password= state.password,
                                        mfsCode="",
                                        onSuccess = {
                                            context.router.navigateTo(Screen.HomePage.route)
                                        }
                                ))
                            },
                            onForgottenPasswordClick={
                                viewModel.onEvent(
                                    LoginEvent.SetLoginState(
                                        LoginStateEnum.FORGET_PASSWORD_SEND_CODE
                                    )
                                )
                            }
                        )
                    }

                    LoginStateEnum.VERIFY_SIGN_IN_CODE->{

                        VerifySignInCode(
                            mfaCode=state.mfaCode,
                            loading=state.isLoading,
                            info = Strings.current().verificationInfo,
                            infoHeader=Strings.current().multiFactorAuthentication,
                            onMFACodeChange={
                                viewModel.onEvent(LoginEvent.OnMFAChange(it))
                            },
                            onCancelClick = {
                                viewModel.onEvent(
                                    LoginEvent.SetLoginState(
                                        LoginStateEnum.SIGN_IN
                                    )
                                )
                            },
                            onSubmitClick={
                                viewModel.onEvent(
                                    LoginEvent.OnSignInClick(
                                        userName =state.userName,
                                        password= state.password,
                                        mfsCode=state.mfaCode,
                                        onSuccess = {
                                            context.router.navigateTo(Screen.HomePage.route)
                                        }
                                    ))
                            }
                        )
                    }

                    LoginStateEnum.FORGET_PASSWORD_SEND_CODE->{
                        ForgetPasswordSendCode(
                            info =Strings.current().forgetPassInfo ,
                            email = state.userName,
                            loading = state.isLoading,
                            onEmailChange = {
                                viewModel.onEvent(LoginEvent.OnUserNameChange(it))
                            },
                            onCancelClick={
                                viewModel.onEvent(
                                    LoginEvent.SetLoginState(
                                        LoginStateEnum.SIGN_IN
                                    )
                                )
                            },
                            onSubmitClick={
                                viewModel.onEvent(
                                    LoginEvent.SendCodeForResetPassword(
                                        state.userName
                                    )
                                )
                            }
                        )
                    }

                    LoginStateEnum.RESET_PASSWORD->{
                        ResetPassword(
                            info =Strings.current().forgetPassInfo2,
                            loading=state.isLoading,
                            onCancelClick={
                                viewModel.onEvent(
                                    LoginEvent.SetLoginState(
                                        LoginStateEnum.SIGN_IN
                                    )
                                )
                            },
                            onUpdatePasswordClick = {code:String,newPassword->
                                viewModel.onEvent(
                                    LoginEvent.ResetPassword(
                                        verifyCode = code,
                                        newPassword=newPassword
                                    )
                                )
                            }
                        )
                    }
                }











            }




        }
    }

}











